import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeInUp } from '../constants';
import { colors } from '../theme/colors';
import {
  BulletItem,
  BulletList,
  CopyColumn,
  Eyebrow,
  EyebrowBadge,
  MediaColumn,
  SectionBody,
  SectionGrid,
  SectionReadMore,
  SectionShell,
  SectionTitle,
} from '../styles/sectionStyles';

function FeatureSection({
  id,
  eyebrow,
  title,
  body,
  bullets = [],
  media,
  reverse = false,
  muted = false,
  linkTo = '/support',
  linkLabel = null,
  badgeColor = colors.couponNormal,
  bulletColor = colors.accent,
}) {
  return (
    <SectionShell id={id} $muted={muted}>
      <SectionGrid
        as={motion.div}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-10% 0px' }}
        variants={fadeInUp}
      >
        <CopyColumn as={motion.div} variants={fadeInUp} style={reverse ? { order: 2 } : undefined}>
          {eyebrow ? (
            <Eyebrow as={motion.div} variants={fadeInUp}>
              <EyebrowBadge $bg={badgeColor}>{eyebrow}</EyebrowBadge>
            </Eyebrow>
          ) : null}
          <SectionTitle as={motion.h2} variants={fadeInUp}>
            {title}
          </SectionTitle>
          {body ? (
            <SectionBody as={motion.p} variants={fadeInUp}>
              {body}
            </SectionBody>
          ) : null}
          {bullets.length > 0 && (
            <BulletList as={motion.ul} variants={fadeInUp}>
              {bullets.map((item) => (
                <BulletItem key={item} $dot={bulletColor}>
                  {item}
                </BulletItem>
              ))}
            </BulletList>
          )}
          {linkLabel && (
            <motion.div variants={fadeInUp}>
              <SectionReadMore to={linkTo}>
                {linkLabel}
                <ArrowRight size={16} aria-hidden="true" />
              </SectionReadMore>
            </motion.div>
          )}
        </CopyColumn>
        <MediaColumn as={motion.div} variants={fadeInUp} style={reverse ? { order: 1 } : undefined}>
          {media}
        </MediaColumn>
      </SectionGrid>
    </SectionShell>
  );
}

export default FeatureSection;
